// extracted by mini-css-extract-plugin
export default {"productCarousel":"A1-z"};